import DateColumn from "@isceco/widget-library2/basic-elements/List/column/DateColumn.js";
import StringColumn from "@isceco/widget-library2/basic-elements/List/column/StringColumn.js";
import GenericColumn from "@isceco/widget-library2/basic-elements/List/column/GenericColumn.js";
import OptionalButtonCell from "../../components/StaticDetailList/OptionalButtonCell";
import HelpTextCell from "../../components/StaticDetailList/HelpTextCell";
import WeitergabeStatus from "./WeitergabeStatus";

export default class KontingentMonitoringWeitergabeColumns {

  static getColumns(i18n, annehmenCallback, ablehnenCallback, archiveCallback) {
    return [
      KontingentMonitoringWeitergabeColumns.ART_WEITERGABE_COLUMN(),
      KontingentMonitoringWeitergabeColumns.DATUM_WEITERGABE_COLUMN(),
      KontingentMonitoringWeitergabeColumns.GESCHAEFTSPARTNER_COLUMN(),
      KontingentMonitoringWeitergabeColumns.MENGE_COLUMN(),
      KontingentMonitoringWeitergabeColumns.STATUS_COLUMN(i18n),
      KontingentMonitoringWeitergabeColumns.ANNEHMEN_COLUMN(annehmenCallback),
      KontingentMonitoringWeitergabeColumns.ABLEHNEN_COLUMN(ablehnenCallback),
      KontingentMonitoringWeitergabeColumns.ARCHIVE_COLUMN(archiveCallback)
    ]
  }

  static DATUM_WEITERGABE_COLUMN() {
    return new DateColumn({
      key: 'austauschdatum',
      text: 'kontingentMonitoring.weitergabe.header.datum',
      sortable: true,
    })
  }

  static ART_WEITERGABE_COLUMN() {
    return new StringColumn({
      key: 'art',
      text: 'kontingentMonitoring.weitergabe.header.art',
      translate: true,
    })
  }

  static MENGE_COLUMN() {
    return new StringColumn({
      key: 'menge',
      text: 'kontingentMonitoring.weitergabe.header.austauschmenge',
    })
  }

  static GESCHAEFTSPARTNER_COLUMN() {
    return new StringColumn({
      key: 'geschaeftspartnerName',
      text: 'kontingentMonitoring.weitergabe.header.geschaeftspartner',
    })
  }

  static STATUS_COLUMN(i18n) {
    return new GenericColumn({
      key: 'status',
      text: 'kontingentMonitoring.weitergabe.header.status',
      cell: new HelpTextCell({
        translate: true,
        helpTextArray: row => {
          const helpTextArray = []
          if (row.erstelltVon != null) {
            helpTextArray.push(i18n.translate('kontingentMonitoring.weitergabe.erstellt.von', {benutzer: row.erstelltVon.name, datum: formatDate(row.austauschdatum)}))
          }
          if (row.bestaetigtVon != null) {
            helpTextArray.push(i18n.translate('kontingentMonitoring.weitergabe.bestaetigt.von', {benutzer: row.bestaetigtVon.name, datum: formatDate(row.austauschdatum)}))
          }
          if (row.abgelehntVon != null) {
            helpTextArray.push(i18n.translate('kontingentMonitoring.weitergabe.abgelehnt.von', {benutzer: row.abgelehntVon.name, datum: formatDate(row.austauschdatum)}))
          }
          return helpTextArray
        }
      })
    })
  }

  static ANNEHMEN_COLUMN(annehmenCallback) {
    return new GenericColumn({
      weight: 0,
      align: 'right',
      cell: new OptionalButtonCell({
        icon: 'check',
        variant: 'primary',
        callback: annehmenCallback,
        show: row => row.isAnnahme && row.statusRaw !== WeitergabeStatus.ABGELEHNT && row.statusRaw !== WeitergabeStatus.ANGENOMMEN
      })
    })
  }

  static ABLEHNEN_COLUMN(ablehnenCallback) {
    return new GenericColumn({
      weight: 0,
      align: 'right',
      cell: new OptionalButtonCell({
        icon: 'times',
        variant: 'danger',
        callback: ablehnenCallback,
        show: row => row.isAnnahme &&  row.statusRaw !== WeitergabeStatus.ABGELEHNT && row.statusRaw !== WeitergabeStatus.ANGENOMMEN
      })
    })
  }

  static ARCHIVE_COLUMN(archiveCallback) {
    return new GenericColumn({
      weight: 0,
      align: 'right',
      cell: new OptionalButtonCell({
        icon: 'trash alternate outline',
        variant: 'danger',
        callback: archiveCallback,
        show: row => !row.isAnnahme && row.statusRaw !== WeitergabeStatus.ABGELEHNT && row.statusRaw !== WeitergabeStatus.ANGENOMMEN
      })
    })
  }
}
